<template>
  <div :class="$style.blockingContainer">
    <fulfilling-bouncing-circle-spinner :animation-duration="2000" :size="65" :color="$style['v-dark']" />
    <p v-if="text" class="mt-2">{{ text }}</p>
  </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners';

export default {
  components: {
    FulfillingBouncingCircleSpinner,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" module>
@import '@design';
.blockingContainer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
}
:export {
  #{'v-dark'}: $dark;
}
</style>
